import { Link } from "react-router-dom";
import { Brain, ArrowRight } from "lucide-react";

export default function QuizTeaser() {
  return (
    <section className="bg-muted/40 py-24 md:py-32">
      <div className="max-w-7xl mx-auto px-6 md:px-10 grid md:grid-cols-12 gap-10 items-center">
        <div className="md:col-span-7">
          <span className="text-xs uppercase tracking-[0.25em] text-secondary font-medium inline-flex items-center gap-2">
            <Brain className="w-3.5 h-3.5" /> Student Friendly
          </span>
          <h2 className="font-serif text-4xl md:text-5xl tracking-tight text-primary mt-3 leading-[1.1]">
            Think you know <em className="not-italic text-secondary">money</em>?
          </h2>
          <p className="mt-5 text-foreground/75 leading-relaxed max-w-xl">
            Take our 7-question finance quiz. No marks, no judgement — just a friendly way to see how
            much you really know about investing. (Spoiler: most adults score 4/7.)
          </p>
          <Link
            to="/quiz"
            className="inline-flex items-center gap-2 mt-8 bg-primary text-primary-foreground rounded-full px-7 py-3.5 font-medium hover:-translate-y-0.5 transition-transform"
          >
            Start the Quiz <ArrowRight className="w-4 h-4" />
          </Link>
        </div>
        <div className="md:col-span-5">
          <div className="relative">
            <div className="absolute -top-6 -right-6 w-32 h-32 rounded-full bg-secondary/20 blur-2xl"></div>
            <div className="grid grid-cols-2 gap-3 relative">
              {["📈","🎯","💡","🌱"].map((e, i) => (
                <div key={i} className="aspect-square bg-card rounded-2xl border border-border grid place-items-center text-5xl shadow-sm">
                  {e}
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
